var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 9.00008C7.4585 9.00008 7.85086 8.83689 8.17725 8.5105C8.50363 8.18411 8.66683 7.79175 8.66683 7.33341C8.66683 6.87508 8.50363 6.48272 8.17725 6.15633C7.85086 5.82994 7.4585 5.66675 7.00016 5.66675C6.54183 5.66675 6.14947 5.82994 5.82308 6.15633C5.49669 6.48272 5.3335 6.87508 5.3335 7.33341C5.3335 7.79175 5.49669 8.18411 5.82308 8.5105C6.14947 8.83689 6.54183 9.00008 7.00016 9.00008ZM7.00016 17.3334C4.76405 15.4306 3.09391 13.6633 1.98975 12.0313C0.885579 10.3994 0.333496 8.88897 0.333496 7.50008C0.333496 5.41675 1.00363 3.75703 2.34391 2.52091C3.68419 1.2848 5.23627 0.666748 7.00016 0.666748C8.76405 0.666748 10.3161 1.2848 11.6564 2.52091C12.9967 3.75703 13.6668 5.41675 13.6668 7.50008C13.6668 8.88897 13.1147 10.3994 12.0106 12.0313C10.9064 13.6633 9.23627 15.4306 7.00016 17.3334Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRed);
export default __webpack_public_path__ + "static/media/location-red.0f57af77c7f7a78d6f871a75347b4939.svg";
export { ForwardRef as ReactComponent };